"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { DataBuilderFormulaType } from '@membranehq/sdk';
import { ValueType } from '../../value-spec.mjs';

const formulaConfigMapping = {
  [DataBuilderFormulaType.VAR]: {},
  [DataBuilderFormulaType.TPL]: {},
  [DataBuilderFormulaType.RECORD]: {},
  [DataBuilderFormulaType.FIRST_NAME]: {
    name: "Extract First Name",
    appliesToSpec: appliesToString
  },
  [DataBuilderFormulaType.LAST_NAME]: {
    name: "Extract Last Name",
    appliesToSpec: appliesToString
  },
  [DataBuilderFormulaType.ITERATE]: {
    name: "Iterate over a list",
    appliesToSpec: appliesToArray
  },
  [DataBuilderFormulaType.CONCAT]: {
    name: "Combine strings",
    appliesToSpec: appliesToString
  },
  [DataBuilderFormulaType.LOOKUP]: {},
  [DataBuilderFormulaType.MAP]: {
    name: "Mapped Value",
    appliesToSpec: appliesToAny
  },
  [DataBuilderFormulaType.CASE]: {
    name: "Conditional Value",
    appliesToSpec: appliesToAny
  },
  [DataBuilderFormulaType.PLAIN]: {},
  [DataBuilderFormulaType.EXTRACT_DATE]: {
    name: "Extract Date",
    appliesToSpec: appliesToDate
  },
  [DataBuilderFormulaType.EXTRACT_TIME]: {
    name: "Extract Time",
    appliesToSpec: appliesToTime
  },
  [DataBuilderFormulaType.COPY]: {
    name: "Copy Value from Another Field"
  },
  [DataBuilderFormulaType.FIND_APP_RECORD_ID]: {
    name: "Find App Record ID",
    appliesToSpec: appliesToAny
  },
  [DataBuilderFormulaType.FIND_EXTERNAL_RECORD_ID]: {
    name: "Find External Record ID",
    appliesToSpec: appliesToAny
  },
  [DataBuilderFormulaType.EVAL]: {},
  [DataBuilderFormulaType.AND]: {},
  [DataBuilderFormulaType.OR]: {},
  [DataBuilderFormulaType.MERGE_OBJECTS]: {
    name: "Merge Objects",
    appliesToSpec: appliesToObject
  },
  [DataBuilderFormulaType.FIRST_NOT_EMPTY]: {
    name: "First Not Empty",
    appliesToSpec: appliesToAny
  },
  [DataBuilderFormulaType.DOMAIN_FROM_EMAIL]: {
    name: "Domain From Email",
    appliesToSpec: appliesToString
  },
  [DataBuilderFormulaType.FORMULA]: {
    name: "Formula"
  },
  [DataBuilderFormulaType.JSONATA]: {
    name: "Jsonata Expression",
    appliesToSpec: appliesToAny
  },
  [DataBuilderFormulaType.DATA_SCHEMA_REF]: {}
};
function appliesToAny() {
  return true;
}
function appliesToString(spec) {
  return Boolean(spec.type === ValueType.STRING && spec.allowCustom);
}
function appliesToArray(spec) {
  return spec.type === ValueType.ARRAY;
}
function appliesToDate(spec) {
  return spec.type === ValueType.DATE;
}
function appliesToTime(spec) {
  return spec.type === ValueType.TIME;
}
function appliesToObject(spec) {
  return spec.type === ValueType.OBJECT;
}

export { formulaConfigMapping };
